define('TavanoTeam.DoubleUnitSales.Model'
,	[	'Backbone'
    ,	'underscore'
    ,	'Utils'
]
,	function (
    Backbone
    ,	_
    ,	Utils
)
{
    'use strict';

    return Backbone.Model.extend({

        urlRoot: Utils.getAbsoluteUrl(getExtensionAssetsPath('services/DoubleUnitSales.Service.ss'))
        ,	validation: {
            zip: {
                required: true
                ,	msg: _('Zip is required').translate()
            }
            ,	quantity: {
                required: true
                ,	msg: _('Quantity is required').translate()
            }
            ,	email: {
                required: true
                ,	pattern: 'email'
                ,	msg: _('Email is required').translate()
            }
        }
    });
});
